/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMiscBillHist.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/misc-bill-hist";

export class AutogenModelMiscBillHist<RowType extends ModelRow> extends Endpoint<RowType, RowMiscBillHistFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMiscBillHist extends ModelRow<RowMiscBillHistFields> {
	constructor(values?: Partial<RowMiscBillHistFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMiscBillHistFields {
	bill_date: Date;
	bill_type: string;
	billing_user_id: string;
	company_id: string;
	"customer.name": string;
	customer_id: string;
	gp_exported: Date;
	id: string;
	invoice_no: number;
	invoice_no_string: string;
	order_id: string;
	post_key: string;
	post_module: string;
	purchase_order_no: string;
	ready_to_process: string;
	reference_number: string;
	remark: string;
	total_charges: number;
	total_charges_c: string;
	total_charges_d: Date;
	total_charges_n: number;
	total_charges_r: number;
	totalcharge_and_excisetax: number;
	totalcharge_and_excisetax_c: string;
	totalcharge_and_excisetax_d: Date;
	totalcharge_and_excisetax_n: number;
	totalcharge_and_excisetax_r: number;
	tw_seg_code: string;
}

